import PromotedGiverForm from './PromotedGiverForm';
import { useSelector } from 'react-redux';
import { useParams } from 'react-router';
import { useContext } from 'react';
import { PostPaymentStepDoneContext } from '../../post-payment/PostPayment';
import GiveContentWrapper from '../../post-payment/GiveContentWrapper';

const PostPaymentPromotedGiver = () => {
    const transactionForGiverInfo = useSelector((state) => state.transactions.transactionForGiverInfo);
    const existingName = transactionForGiverInfo?.from_user_meta_data?.name;
    const { transactionId, transactionNonce } = useParams();
    const { done } = useContext(PostPaymentStepDoneContext);

    return (
        <GiveContentWrapper>
            <PromotedGiverForm done={done} name={existingName} transactionInfo={{ transactionId, transactionNonce }} />
        </GiveContentWrapper>
    );
};

export default PostPaymentPromotedGiver;
